// @flow
import * as React from 'react';
import { FieldWrapper } from 'speed-js-react-web';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';


type Props = {
    value: ?string,
    choices: Object,
    label: React.Node,
    placeholder: React.Node,
    onChange: Function,
    required?: boolean,
};

const NoFormSelect = (props: Props) => {
    const {
        value, choices, label, placeholder, onChange, required,
    } = props;

    return (
        <FieldWrapper label={label} required={required}>
            <BaseSelect
                emptyLabel=""
                choices={choices}
                value={value || null}
                onChange={onChange}
            />
        </FieldWrapper>
    );
};

NoFormSelect.defaultProps = {
    required: false,
    placeholder: '',
};

export default NoFormSelect;
